import { NormalButton } from "@/frontend/shared/ui/Button";
import { Input } from "@/frontend/shared/ui/Input";
import { Modal } from "@/frontend/shared/ui/Modal";
import { useState } from "react";
import styles from "./RenameStageModal.module.scss";
import { CancelButton } from "@/frontend/shared/ui/Button/CancelButton/CancelButton";

interface RenameStageModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialValue: string;
  renameStage: (newName: string) => void;
  columns: string[];
  isLoading: boolean;
}

export function RenameStageModal(props: RenameStageModalProps) {
  const { isOpen, onClose, initialValue, renameStage, columns, isLoading } = props;

  const [value, setValue] = useState(initialValue);
  const [inputError, setInputError] = useState<string>("");

  function handleChange(value: string) {
    setInputError("");
    setValue(value);
  }

  function validateInput(value: string): boolean {
    let hasErrors = false;

    if (columns.includes(value.trim())) {
      setInputError("Stage with this name already exists");
      hasErrors = true;
    } else if (value.length > 20) {
      setInputError("Name is too long");
      hasErrors = true;
    }
    return hasErrors;
  }

  function handleSubmit() {
    const hasErrors = validateInput(value);
    if (hasErrors) {
      return;
    }
    renameStage(value);
  }

  const submitDisabled = !value || !!inputError || isLoading;

  function handleClose() {
    setInputError("");
    setValue(initialValue);
    onClose();
  }

  return (
    <div>
      <Modal isOpen={isOpen} onClose={handleClose} title="Rename" isHeader minHeight="240px">
        <div className={!!inputError ? styles.inputError : undefined}>
          <Input
            value={value}
            inputSize="small"
            placeholder="Provide a new name for stage"
            onChange={(e) => handleChange(e.target.value)}
            error={inputError}
            isError={!!inputError}
          />
        </div>
        <div className={styles.optionContainer}>
          <CancelButton size="large" onClick={handleClose}>
            Cancel
          </CancelButton>
          <NormalButton size="large" onClick={handleSubmit} isDisabled={submitDisabled}>
            Save
          </NormalButton>
        </div>
      </Modal>
    </div>
  );
}
